// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerResponse

export type CustomerApiResponse = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	isVip: boolean;
	totalSpent: number;
	firstBookingId: string | null;
	lastBookingId: string | null;
	totalBookings: number;
	preferredLocale: string;
	tags: Array<string>;
	customFields: Record<string, string>;
};

export type Customer = {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	phone: string;
	phoneOptIn: boolean;
	emailOptIn: boolean;
	isVip: boolean;
	totalSpent: number;
	firstBookingId: string | null;
	lastBookingId: string | null;
	totalBookings: number;
	preferredLocale: string;
	tags: Array<string>;
	customFields: Record<string, string>;
};

export function hydrateCustomer(data: CustomerApiResponse): Customer {
	return {
		...data,
		customFields: Array.isArray(data.customFields) ? {} : data.customFields,
	};
}